var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#active-driver-shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22,
    r: 19,
    fill: "#4A7BEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 30H30C29.4 30 29 29.6 29 29C29 28.4 29.4 28 30 28H31C31.6 28 32 27.6 32 27V24.2L30.3 20H27V27C27 27.6 26.6 28 26 28C25.4 28 25 27.6 25 27V19C25 18.4 25.4 18 26 18H31C31.4 18 31.8 18.2 31.9 18.6L33.9 23.6C33.9 23.7 34 23.8 34 24V27C34 28.7 32.7 30 31 30Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32C26.3 32 25 30.7 25 29C25 27.3 26.3 26 28 26C29.7 26 31 27.3 31 29C31 30.7 29.7 32 28 32ZM28 28C27.4 28 27 28.4 27 29C27 29.6 27.4 30 28 30C28.6 30 29 29.6 29 29C29 28.4 28.6 28 28 28Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C16.3 32 15 30.7 15 29C15 27.3 16.3 26 18 26C19.7 26 21 27.3 21 29C21 30.7 19.7 32 18 32ZM18 28C17.4 28 17 28.4 17 29C17 29.6 17.4 30 18 30C18.6 30 19 29.6 19 29C19 28.4 18.6 28 18 28Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H20C19.4 30 19 29.6 19 29C19 28.4 19.4 28 20 28H25V17C25 16.4 24.6 16 24 16H15C14.4 16 14 16.4 14 17V27C14 27.6 14.4 28 15 28C15.6 28 16 28.4 16 29C16 29.6 15.6 30 15 30C13.3 30 12 28.7 12 27V17C12 15.3 13.3 14 15 14H24C25.7 14 27 15.3 27 17V29C27 29.6 26.6 30 26 30Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27H31.5C30.9 27 30.5 26.6 30.5 26C30.5 25.4 30.9 25 31.5 25H33C33.6 25 34 25.4 34 26C34 26.6 33.6 27 33 27Z",
    fill: "#FFFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active-driver-shadow",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIconActive);
export default __webpack_public_path__ + "static/media/driver-icon-active.37cb515e070629876d209d44386cb773.svg";
export { ForwardRef as ReactComponent };